"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ramda = require("ramda");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var PersonalIntegration = _interopRequireWildcard(require("../../../PersonalIntegration"));

var _gift = require("../../store/gift/gift.selector");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _useCheckIntegrationsAvailability = require("../../hooks/useCheckIntegrationsAvailability");

var _useTrackBrokenIntegrations = require("../../hooks/useTrackBrokenIntegrations");

var _useCheckIntegrationsReconnect = require("../../hooks/useCheckIntegrationsReconnect");

var useStyles = (0, _styles.makeStyles)({
  connectLink: {
    display: 'inline'
  }
});

var EmailIntegrationBroken = function EmailIntegrationBroken(_ref) {
  var wrapperProps = (0, _extends2.default)({}, _ref);
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var emailProvider = (0, _reactRedux.useSelector)(_gift.getGiftEmailProvider);
  var isDkimProvider = (0, _reactRedux.useSelector)(_gift.getIsDkimEmailProvider);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      emailIntegrationStrategy = _useGiftContext.emailIntegrationStrategy,
      emailIntegrationSettingsUrl = _useGiftContext.emailIntegrationSettingsUrl;

  var currentPath = "".concat(window.location.pathname).concat(window.location.search);
  var brokenIntegrationProvider = (0, _ramda.propOr)('', 'broken_integration_provider', emailProvider);
  var handleStartIntegrationChecking = (0, _useCheckIntegrationsAvailability.useCheckIntegrationsAvailability)(emailIntegrationSettingsUrl);
  var handleTrackReconnect = (0, _useTrackBrokenIntegrations.useTrackReconnectIntegration)(brokenIntegrationProvider);
  var handleIntegrationClick = (0, _react.useCallback)(function (event) {
    event.preventDefault(); // Open ED integrations settings for CE application.

    if (emailIntegrationSettingsUrl) {
      handleStartIntegrationChecking(true);
      window.open(emailIntegrationSettingsUrl, '_blank');
      return;
    }

    var scopes = {
      email: !isDkimProvider,
      calendar: true
    };
    dispatch(PersonalIntegration.actions.openIntegrationService(emailIntegrationStrategy === 'salesforce' ? {
      service: brokenIntegrationProvider,
      script: emailIntegrationStrategy,
      scopes
    } : {
      service: brokenIntegrationProvider,
      path: currentPath,
      scopes
    }));
    handleTrackReconnect();
  }, [currentPath, dispatch, emailIntegrationStrategy, emailIntegrationSettingsUrl, isDkimProvider, brokenIntegrationProvider, handleStartIntegrationChecking, handleTrackReconnect]);
  (0, _useTrackBrokenIntegrations.useTrackBrokenIntegration)(brokenIntegrationProvider);
  (0, _useCheckIntegrationsReconnect.useCheckIntegrationsReconnect)();
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    my: 1,
    display: "flex",
    flexDirection: "row"
  }, wrapperProps), /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "error"
  }, /*#__PURE__*/_react.default.createElement(_material.AlertTitle, null, "Your ", brokenIntegrationProvider, " email integration has been disconnected."), "Please", ' ', /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    className: (0, _classnames.default)(classes.connectLink, 'Subcopy-Regular-Link'),
    onClick: handleIntegrationClick
  }, "reconnect"), ' ', "your email account to Alyce in order to send your gift invitation from your email address."));
};

var _default = /*#__PURE__*/(0, _react.memo)(EmailIntegrationBroken);

exports.default = _default;